module.exports = __webpack_public_path__ + "static/img/retail_img_1_en.1137924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/retail_img_1_en.png
// module id = ZJkw
// module chunks = 0